import React from "react";
import CIcon from "@coreui/icons-react";
import {
  cilSpeedometer,
  cilBasket,
  cilCart,
  cilClock,
  cilGift,
  cilWallet,
  cilSettings,
  cilMonitor,
  cilMap,
  cilTruck,
  cilPeople,
} from "@coreui/icons";
import { CNavGroup, CNavItem, CNavTitle } from "@coreui/react-pro";

const Nav = [
  {
    component: CNavItem,
    name: "Dashboard",
    to: "/dashboard",
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
    // badge: {
    //   color: "secondary",
    //   text: "EN VIVO",
    // },
  },

  /* -------------------------------------------------------------------------- */
  /*                            GESTIÓN DE LA TIENDA                            */
  /* -------------------------------------------------------------------------- */
  {
    component: CNavTitle,
    name: "OPERACIÓN DE TIENDA",
  },
  {
    component: CNavGroup,
    name: "Órdenes",
    icon: <CIcon icon={cilCart} customClassName="nav-icon" />,
    to: "/orders",
    items: [
      {
        component: CNavItem,
        name: "Todas",
        to: "/orders",
        end: true,
      },
      {
        component: CNavItem,
        name: "Por atender",
        to: "/orders/active",
      },
      {
        component: CNavItem,
        name: "Recoger en tienda",
        to: "/orders/pickup",
      },
      {
        component: CNavItem,
        name: "Historial",
        to: "/orders/history",
      },
    ],
  },
  {
    component: CNavGroup,
    name: "Productos",
    icon: <CIcon icon={cilBasket} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "Listado",
        to: "/products/list",
      },
      {
        component: CNavItem,
        name: "Crear",
        to: "/products/create",
      },
      {
        component: CNavItem,
        name: "Combos",
        to: "/combos/list",
      },
      // {
      //   component: CNavItem,
      //   name: "Categorías",
      //   to: "/products/categories",
      // },
    ],
  },
  {
    component: CNavItem,
    name: "Horarios",
    to: "/store/schedules",
    icon: <CIcon icon={cilClock} customClassName="nav-icon" />,
  },

  /* -------------------------------------------------------------------------- */
  /*        MI FLOTA (empresas de domicilios): fleet = true -> solo si el      */
  /*        usuario pertenece a una empresa (ver SideBar)                       */
  /* -------------------------------------------------------------------------- */
  {
    component: CNavTitle,
    name: "MI FLOTA",
    fleet: true,
  },
  {
    component: CNavItem,
    name: "Flota en vivo",
    to: "/fleet/live",
    icon: <CIcon icon={cilMap} customClassName="nav-icon" />,
    fleet: true,
  },
  {
    component: CNavItem,
    name: "Pedidos de la flota",
    to: "/fleet/deliveries",
    icon: <CIcon icon={cilTruck} customClassName="nav-icon" />,
    fleet: true,
  },
  {
    component: CNavItem,
    name: "Domiciliarios",
    to: "/fleet/couriers",
    icon: <CIcon icon={cilPeople} customClassName="nav-icon" />,
    fleet: true,
  },

  /* -------------------------------------------------------------------------- */
  /*                           CRECIMIENTO Y FIDELIDAD                          */
  /* -------------------------------------------------------------------------- */
  {
    component: CNavTitle,
    name: "MARKETING & CLIENTES",
  },
  {
    component: CNavGroup,
    name: "Promociones",
    icon: <CIcon icon={cilGift} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "Descuentos y eventos",
        to: "/marketing/discounts",
      },
      {
        component: CNavItem,
        name: "Publicidad",
        to: "/marketing/ads",
      },
      {
        component: CNavItem,
        name: "Programa de Referidos",
        to: "/marketing/referrals",
      },
    ],
  },
  /* -------------------------------------------------------------------------- */
  /*                             FINANZAS & CPANEL                              */
  /* -------------------------------------------------------------------------- */
  {
    component: CNavTitle,
    name: "ADMINISTRACIÓN",
  },
  {
    component: CNavItem,
    name: "Billetera",
    to: "/finance/balance",
    icon: <CIcon icon={cilWallet} customClassName="nav-icon" />,
  },
  {
    component: CNavGroup,
    name: "SuperAdmin Panel",
    icon: <CIcon icon={cilMonitor} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "Recorrido de entregas",
        to: "/admin/cpanel/routes",
      },
    ],
  },
  {
    component: CNavItem,
    name: "Configuración",
    to: "/settings",
    icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
  },
];

export default Nav;